import React, { memo } from 'react';
import { SignerWidgetForm } from './SignerBlock';
import { FormHTML } from '@core/components/form/FormHTML';
import { FormControl } from '@core/utils/form';
export interface SignerBlockSettingsProps {
  form: SignerWidgetForm;
  terms?: FormControl<string>;
}

export const SignerBlockSettings = memo((props: SignerBlockSettingsProps) => {
  const { terms } = props;

  return <div>{!!terms && <FormHTML control={terms} minimal />}</div>;
});
